import Grid from './Grid'
import Row from './Row'
import Column from './Column'

const Table = Grid

Table.Row = Row
Table.Column = Column

export default Table

